import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import {EventModel} from "../../models/event.model";
import ActionButton from "../../components/button/button.component";
import {useNavigate} from "react-router-dom";
import toast from "react-hot-toast";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import {ApiResponseModel} from "../../models/apiresponse.model";
import {getCurrentUser, UserModel} from "../../store/reducers/user/user.reducer";
import {useSelector} from "react-redux";
import AdvancedTable from "../../components/tables/advanced_table.component";
import DeleteMenu from "../../components/menu/delete-menu.component";

export default function EventsPage() {
    const navigate = useNavigate();

    const currentUser: UserModel = useSelector(getCurrentUser);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [events, setEvents] = useState<EventModel[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pages, setPages] = useState<number>(1);
    const [open, setOpen] = useState<boolean>(false);
    const [deletingId, setDeletingId] = useState<string>("");

    useEffect(() => {
        getEvents();

        return () => {};
    }, []);

    const navigateToCreate = () => navigate("/esemenyek/letrehozas");
    const navigateToUpdate = (id: string) => navigate(`/esemenyek/szerkesztes/${id}`);

    const getEvents = async () => {
        try {
            setIsLoading(true);

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.GET,
                endpoint: `event?page=${page}&limit=10`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a lekérdezése közben! (${response?.error ?? "Nincs bővebb információ!"})`)
                return;
            }

            let apiResponseModel: ApiResponseModel = response.data;

            setPages(apiResponseModel.data.pages ?? 1);
            setEvents(apiResponseModel.data.data);
            setIsLoading(false);
        } catch (error) {
            toast.error("Hiba! Nem sikerült lekérdezni a létrehozott eseményeket!");
        }
    }
    const handlePageChange = async (page: number) => {
        try {

        } catch (error: any) {
            toast.error(`Hiba a törlés közben! (${error.message ?? "Nincs bővebb információ!"})`)
        }

        setIsLoading(true);

        const response = await sendApiRequest({
            headers: {
                "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                'Authorization': 'Bearer ' + currentUser.token
            },
            method: NetworkMethods.GET,
            endpoint: `event?page=${page}&limit=10`,
        });

        if (!response.isSuccess) {
            toast.error(`Hiba a lekérdezése közben! (${response?.error ?? "Nincs bővebb információ!"})`)
            return;
        }

        let apiResponseModel: ApiResponseModel = response.data;

        setPage(page);
        setPages(apiResponseModel.data.pages ?? 1);
        setEvents(apiResponseModel.data.data);
        setIsLoading(false);
    };
    const handleDelete = async () => {
        try {
            if (deletingId == "") return;

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.DELETE,
                endpoint: `event/id/${deletingId}`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a törlés közben! (${response?.error ?? "Nincs bővebb információ!"})`);
                return;
            }

            toast.success(`Sikeres törlés!`);
            await getEvents();
        } catch (error: any) {
            toast.error(`Hiba a törlés közben! (${error?.message ?? "Nincs bővebb információ!"})`);
        }
    }

    if (isLoading) {
        return <div>Betöltés...</div>
    }

    return (
      <div>
        <SiteBreadCrumb
          sites={[
            {
              name: "Főoldal",
              url: "/",
            },
            {
              name: "Események",
              url: "/esemenyek",
            },
          ]}
        />
        <Typography variant="h3">Esemény varázsló</Typography>
        <br />
        <ActionButton
          title="Új esemény létrehozása"
          type={"ADD"}
          action={navigateToCreate}
        />
        <br />
        <br />
        <Typography variant="h3">Elérhető bejegyzések</Typography>
        <br />
        <AdvancedTable
          columns={["ID", "Bejegyzés címe"]}
          rows={
            events &&
            events.map((event) => ({
              id: event.id,
              title: event.title,
            }))
          }
          properties={{
            page: page,
            pages: pages,
            rowsPerPage: 10,
            totalRows: pages * 10,
            disableSee: false,
            disableEdit: true,
            disableDelete: false,
          }}
          rowActions={{
            deleteAction: (row: any) => {
              setDeletingId(row.id);
              setOpen(true);
            },
            editAction: () => {},
            seeAction: (row: any) => navigateToUpdate(row.id),
          }}
          pageChange={handlePageChange}
        />

        <DeleteMenu
          open={open}
          handleClose={() => setOpen(!open)}
          handleDelete={handleDelete}
        />
      </div>
    );
}